var submitedFormSelector = ''; // variable of just submitted form on the page (used if we have more than one forms on the page)
var activeFormSelector = ''; // variable of currently active form on the page (used if we have more than one forms on the page)
function isObject(item) { // Utility which detects objects (not arrays)
    return (item && typeof item === 'object' && !Array.isArray(item));
}

function mergeDeep(target, ...sources) { // merges 2 or more objects including nested objects
    if (!sources.length)
        return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key])
                    Object.assign(target, {[key]: {}});
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, {[key]: source[key]});
            }
        }
    }
    return mergeDeep(target, ...sources);
}

/* This function allows to add ajax form submitting wth validation and recaptcha. Usage:
 *  irisValidation($('#form-selector'), {
      focusFirstInput: false,
      validators: {
        firstname: 'firstName',
        lastname: 'lastName',
        email: 'email',
        company: 'companyName',
      },
      filters: {
        utm_source: 'utm_param',
        utm_campaign: 'utm_param',
        utm_medium: 'utm_param',
        conversion_url: 'page_url',
        utm_gclid: 'utm_param',
        utm_term: 'utm_param',
        utm_content: 'utm_param',
        pagename: 'page_url',
      },
      validateByTimeout: ['email'],
      errorMessages: {
        required: 'This field is required',
        emailFormat: 'Not a valid email',
        connectionError: 'Server connection error. Please try again later.', // Text of error when we have some connection errors
      },
      success: function (data) {
        
      }
    });
 */

function irisValidation(element, settings) { 
    if (!$(element).attr('id')) {
        console.error('From should have an ID');
    }

    var iris_validator = {
        defaultSettings: {
            url: '', // URL where to post (if empty form "action" param will be used)
            hasFiles: false, // Form has file fields
            captchaTheme: 'light', // Recaptcha color scheme 
            formInvalidClass: 'has-error', // Class which adds to element container if it has error
            formValidClass: 'has-success', // Class which adds to element container if it has no error
            formProgressClass: 'has-progress', // Class which adds to element container if it has progress
            formErrorClass: 'help-block with-errors', // Class of element with error description
            formErrorTag: 'div', // tag of elemrnt error description
            formParentClass: 'form-group', // Class of element container
            formElementClass: 'form-control', // Class of element
            focusFirstInput: false, // Put cursor into first input of the form. WARNING! It scrolls the page to the form.
            errorMessages: { // Error messages for different error types. You can add more messages in settings during initialization
                required: 'Please fill out this field.',
                firstNameLong: 'First Name is too long',
                firstNameFormat: 'Only letters and digits are allowed in First Name',
                lastNameLong: 'Last Name is too long',
                lastNameFormat: 'Only letters and digits are allowed in Last Name',
                emailFormat: 'Please enter a valid email address',
                urlFormat: 'Please enter a valid URL',
                phoneFormat: 'Phone number must contain 10 digits',
                companyNameLong: 'Company Name is too long',
                companyNameFormat: 'Your Company Name has invalid format',
                fileBig: 'You can\'t upload files larger than 10MB',
                fileEmpty: 'You can\'t upload empty files',
                fileFormat: 'You are not allowed to upload files of this type',
                connectionError: 'Server connection error. Please try again later.', // Text of error when we have some connection errors
                captchaError: 'Please complete the captcha and submit again.', // Text of error when captcha validation failed
            },
            filters: { // Filters (functions which runs at initializations and during the field change) can have name of the function 
              // from "baseFilters" - phoneMask, utm_param, page_url, file. 
              // Or have function (element) for custom filters
              utm_campaign: 'utm_param',
              utm_content: 'utm_param',
              utm_medium: 'utm_param',
              utm_source: 'utm_param',
              utm_term: 'utm_param',
              utm_adgroupid: 'utm_param',
              utm_campaignid: 'utm_param',
              utm_creative: 'utm_param',
              utm_device: 'utm_param',
              gclid: 'utm_param',
              utm_keyword: 'utm_param',
              utm_matchtype: 'utm_param',
              utm_network: 'utm_param',
              utm_targetid: 'utm_param',
              li_fat_id: 'utm_param',
              msclkid: 'utm_param',
              fbclid: 'utm_param',
              channel_type: 'utm_param',
              conversion_url: 'page_url',
              utm_gclid: 'utm_param',
              pagename: 'page_url',
              utm_adgroup: 'utm_param',
              leadsource: 'utm_param',
              ft_utm_campaign: 'utm_param',
              ft_utm_content: 'utm_param',
              ft_utm_medium: 'utm_param',
              ft_utm_source: 'utm_param',
              ft_utm_term: 'utm_param',
              ft_utm_adgroupid: 'utm_param',
              ft_utm_campaignid: 'utm_param',
              ft_utm_creative: 'utm_param',
              ft_utm_device: 'utm_param',
              ft_gclid: 'utm_param',
              ft_utm_keyword: 'utm_param',
              ft_utm_matchtype:'utm_param',
              ft_utm_network: 'utm_param',
              ft_utm_targetid: 'utm_param',
              ft_li_fat_id: 'utm_param',
              ft_msclkid: 'utm_param', 
              ft_fbclid: 'utm_param',
              ft_channel_type: 'utm_param',
              ft_sfcid:'utm_param',
              whitepaper: 'utm_param',
              honeypot: 'utm_param',
              CampaignId: 'utm_param',
              booking_popup: 'utm_param',
              status: 'utm_param',
            },
            validators: {},// Validators (functions which runs after field was changed and before submit) can have name of the function 
              // from "baseValidators" - firstName, site, lastName, email, url, phone, companyName, file. 
              // Or have function (element) for custom validator
            validateByTimeout: [],
            success: function (data) {
                window.location = data.url;
            },
        },
        formSelector: '#' + $(element).attr('id'), // Selector of the form. Default is ID of the form. For correct work have to be unique for each form on the page
        formSubmitButton: '#' + $(element).find('button[type="submit"]').attr('id'), // Selector of Submit button. By default ID of first SUBMIT button of the form
        tokenSelector: '#' + $(element).attr('id') + ' .g-recaptcha-response', // Selector of the field for reCaptcha token.
        formSubmissionLock: false, // Lock variable for prevent double submission
        emailValidationLock: false, // Lock variable for prevent double email check
        emailValidationField: null, // Variable with email field which currently validating
        hiddenFiltersApplied: false, // Marker variable if hidden filters already applied
        validateByTimeout: [], // List of fields which have to be validated by timeout
        validateTimeouts: {}, // List of timeouts for validating
        validateRequiredTimeouts: {}, // List of timeouts for required validating
        recaptchaAdded: false, // Marker variable if recaptcha already added
        errors: {}, // List of errors
        pageOwnedFields: ['CampaignId', 'status', 'booking_popup', 'Chilipiper_CampaignID', 'Chilipiper_Campaign_Member_Status', 'chilipiper_meeting_topic'], // Fields whose value is set by the page (or current URL), never from localStorage
        baseFilters : { // Pre-defined functions which can be used in "filters"
            phoneMask : (element) => { // applies mask for phone field
                var value = $(element).val();
                $(element).val(iris_validator.createMask(iris_validator.destroyMask(value)));
            },
            utm_param: function (element) { // adds "UTM" data from local storage (parse_utm_data function saves UTMs to local storage in "newpages.js" for new pages and in "custom.js" for legacy ages)
              // Stored values only fill empty fields: a value rendered by the page
              // or taken from the current URL always wins. Page-owned fields never
              // come from storage at all.
              // applyHiddenFilters() passes a jQuery object, field events pass the
              // DOM element — normalize, since defaultValue exists only on the latter.
              var el = $(element)[0];
              if (!el) {
                return;
              }
              var name = $(el).attr('name');
              if (iris_validator.pageOwnedFields.indexOf(name) !== -1 || el.defaultValue !== '' || $(el).val() !== '') {
                return;
              }
              try {
                var value = window.localStorage.getItem(name);
              } catch (e) {
                return;
              }
              if (!!value) {
                $(element).val(value);
              }
            },
            page_url: function (element) { // adds page url to field valure (for different metrics)
              $(element).val(window.location.href);
            },
            file: function(element) { // adds filename to ".fileName" div for styling file input
              var file = null;
              if($(element)[0].files && $(element)[0].files[0]) {
                  file = $(element)[0].files[0];
              }
              if(file) {
                  $(element).parent().addClass('attached').find('.fileName').text(file.name);
              } else {
                  $(element).parent().removeClass('attached').find('.fileName').text('');
              }
            },
        },
        baseValidators: { // Pre-defined functions which can be used in "validators"
            firstName: function (element) { 
                var value = $(element).val();
                var regex = /^[a-zA-Z0-9\s\.\-\`\'\’]*$/gm;
                iris_validator.removeError(element);
                if (value.length > 0) {
                    if (value.length > 30) {
                        iris_validator.showError(element, iris_validator.errorMessages.firstNameLong, '_validator');
                        return;
                    } else if (regex.exec(value) === null) {
                        iris_validator.showError(element, iris_validator.errorMessages.firstNameFormat, '_validator');
                        return;
                    }
                }
            },
            site: function(element) {
                var value = $(element).val();
                if(value.substr(0,7).toLowerCase() !== ('http://').substr(0,value.length) && value.substr(0,8).toLowerCase() !== ('https://').substr(0,value.length) ) {
                    value = 'http://' + value;
                    $(element).val(value);
                }
                var regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm;
                iris_validator.removeError(element);
                if (value.length > 0) {
                    if (regex.exec(value) === null) {
                        iris_validator.showError(element, iris_validator.errorMessages.siteFormat, '_validator');
                        return;
                    }
                }
            },
            lastName: function (element) {
                var value = $(element).val();
                var regex = /^[a-zA-Z0-9\s\.\-\`\'\’]*$/gm;
                iris_validator.removeError(element);
                if (value.length > 0) {
                    if (value.length > 30) {
                        iris_validator.showError(element, iris_validator.errorMessages.lastNameLong, '_validator');
                        return;
                    } else if (regex.exec(value) === null) {
                        iris_validator.showError(element, iris_validator.errorMessages.lastNameFormat, '_validator');
                        return;
                    }
                }
            },
            email: function (element) {
                var value = $(element).val();
                var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@[a-zA-Z0-9]+((\-?[a-zA-Z0-9]{1,})|(\.?[a-zA-Z0-9]+\-?[a-zA-Z0-9]+))*(\.{1}[a-zA-Z]{2,})$/gm;
                iris_validator.removeError(element, '_validator');
                if (value.length > 0) {
                    const domains = ['ncien.com','inupup.com','mirarmax.com','skateru.com', 'hf.com', 'noidem.com', 'adcomfg.com', 'lespedia.com', 'mogash.com', 'qmailx.click', 'talk21.com']; //blocked domains
                    const domainPattern = domains.map(domain => domain.replace(/\./g, '\\.')).join('|');
                    const regex_domains = new RegExp(domainPattern, 'i');
                    if (regex.exec(value) === null || regex_domains.exec(value) != null) {
                        iris_validator.showError(element, iris_validator.errorMessages.emailFormat, '_validator');
                        return;
                    }
                    // Server-side NeverBounce check (admin-ajax `forms_submission_emailcheck`)
                    // was returning 500. Disabled — client-side format + blocked-domain
                    // list above still runs. Re-enable once the backend endpoint is stable.
                    // iris_validator.validateEmail(element, value);
                }
            },
            url: function (element) {
                var value = $(element).val();
                var regex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
                iris_validator.removeError(element, '_validator');
                if (value.length > 0) {
                    if (regex.exec(value) === null) {
                        iris_validator.showError(element, iris_validator.errorMessages.urlFormat, '_validator');
                        return;
                    }
                }
            },
            phone: function (element) {
                var value = $(element).val();
                iris_validator.removeError(element, '_validator');
                $(element).val(iris_validator.createMask(iris_validator.destroyMask(value)));
                if (iris_validator.destroyMask(value).length > 1 && iris_validator.destroyMask(value).length < 5) {
                    iris_validator.showError(element, iris_validator.errorMessages.phoneFormat, '_validator');
                }
            },
            companyName: function (element) {
                var value = $(element).val();
                var regex = /^[A-Za-z0-9 \"“”'‘’()[\]{}<>«»\\\/?!&@£$€¥.,-;:]{3}[*=#%+A-Za-z0-9 \"“”'‘’()[\]{}<>«»\\\/?!&@£$€¥.,-:;]{0,157}$/gm;
                iris_validator.removeError(element);
                if (value.length > 0) {
                    if (value.length > 157) {
                        iris_validator.showError(element, iris_validator.errorMessages.companyNameLong, '_validator');
                        return;
                    } else if (regex.exec(value) === null) {
                        iris_validator.showError(element, iris_validator.errorMessages.companyNameFormat, '_validator');
                        return;
                    }
                }
            },
            file: function(element) {
              iris_validator.removeError(element);
              var file = null;
              if($(element)[0].files && $(element)[0].files[0]) {
                  file = $(element)[0].files[0];
              }
              if(file) {
                  var extension = file.name.split('.').pop().toLowerCase();
                  if(file.size === 0) {
                      iris_validator.showError(element, iris_validator.errorMessages.fileEmpty, '_validator');
                  }
                  if(file.size > 10000000) {
                      iris_validator.showError(element, iris_validator.errorMessages.fileBig, '_validator');
                  }
                  if($.inArray(extension, ['doc', 'docx', 'xls', 'xlsx', 'txt', 'pdf']) == -1) {
                      iris_validator.showError(element, iris_validator.errorMessages.fileFormat, '_validator');
                  }
              }
            },
        },
        filters: { // system object for filters for the fields
            __required: function (element) { // required default filter. Applies for all fields wich have "required" attribute
                iris_validator.removeError(element, '_required');
            },
            __all: function (element) { // all fields filter. Removes error if we start editing the field and applies filters for hidden fields.
                iris_validator.removeError(element, '_validator');
                iris_validator.applyHiddenFilters();
                activeFormSelector = iris_validator.formSelector;
            },

        },
        validators: { // system object for validators for the fields
            __required: function (element) { // required default valdator. Applies for all fields wich have "required" attribute
                iris_validator.removeError(element, '_required');
                if ($(element).val() == '') {
                    iris_validator.showError(element, iris_validator.errorMessages.required, '_required');
                }
            },
        },
        applyHiddenFilters: function() { // Applies filters for hidden fields
          if(!iris_validator.hiddenFiltersApplied){
            iris_validator.hiddenFiltersApplied = true;
            for (var i in iris_validator.formArray) {
              var elementName = iris_validator.formArray[i]['name'];
              var elementSelector = iris_validator.formSelector + ' [name="' + elementName + '"]';
              if($(elementSelector).attr('type') == 'hidden' && typeof (iris_validator.filters[elementName]) == 'function') {
                iris_validator.filters[elementName]($(elementSelector));
              }
            }
          }
        },
        showError: function (element, errorText, errorPrefix) { // Shows error for the field
            var errorPrefix = errorPrefix || '';
            var parent = $(element).parents(iris_validator.classToSelector(iris_validator.formParentClass));
            $(parent).find('[data-marker="' + $(element).attr('name') + errorPrefix + '"]').remove();
            $(parent).addClass(iris_validator.formInvalidClass);
            $(parent).removeClass(iris_validator.formValidClass);
            $(parent).append(iris_validator.errorBlock(errorText, $(element).attr('name') + errorPrefix));
            iris_validator.errors[$(element).attr('name') + errorPrefix] = true;
            iris_validator.checkErrors();
        },
        showSuccess: function (element) { // Show success status for the field
            var parent = $(element).parents(iris_validator.classToSelector(iris_validator.formParentClass));
            $(parent).removeClass(iris_validator.formValidClass);
            var availibleSuffixes = ['_required', '_validator', '_error'];
            var name = $(element).attr('name');
            var error = false;
            if (typeof (iris_validator.errors[name]) !== 'undefined') {
                error = true;
            }
            for (var i in availibleSuffixes) {
                if (typeof (iris_validator.errors[name + availibleSuffixes[i]]) !== 'undefined') {
                    error = true;
                }
            }
            if (!error) {
                $(parent).removeClass(iris_validator.formInvalidClass);
                if (!$(element).hasClass(iris_validator.formProgressClass)) {
                    $(parent).addClass(iris_validator.formValidClass);
                }
            }
            iris_validator.checkErrors();
        },
        removeError: function (element, errorPrefix) { // removes error from the field
            var errorPrefix = errorPrefix || '';
            var parent = $(element).parents(iris_validator.classToSelector(iris_validator.formParentClass));
            $(parent).find('[data-marker="' + $(element).attr('name') + errorPrefix + '"]').remove();
            delete iris_validator.errors[$(element).attr('name') + errorPrefix];
            iris_validator.showSuccess(element);
        },
        errorBlock: function (text, marker) { // Returns error HTML
            return '<' + iris_validator.formErrorTag + ' class="' + iris_validator.formErrorClass + '" data-marker="' + marker + '">' + text + '</' + iris_validator.formErrorTag + '>';
        },
        classToSelector: function (className) { // converts class name to CSS selector
            return '.' + className.replace(' ', '.');
        },
        createMask: function (string) { // creates mask for "phone" field
            string = string.replace(/(\d{14})/, "$1");
            if (string.length > 0) {
              string = '+' + string;
            }
            if (string.length > 3) {
                string = string.substr(0, 4) + ' '+ string.substr(4);
            }
            if (string.length > 7) {
                string = string.substr(0, 7) + ' ' + string.substr(7);
            }
            if (string.length > 11) {
                string = string.substr(0, 11) + ' ' + string.substr(11);
            }
            return string;
        },
        destroyMask: function (string) { // return unmasked value of the phone field
            return string.replace(/\D/g, '').substring(0, 14);
        },
        checkErrors: function () { // checks if form have any error and disbles submit if it have
            if (Object.keys(iris_validator.errors).length > 0) {
                iris_validator.disableSubmit();
            } else {
                iris_validator.enableSubmit();
            }
        },
        applySettings: function (settings) { // combines settings with default settings and applies them for current object
            mergeDeep(this, iris_validator.defaultSettings, settings);
        },
        applyBaseFunctions: function () { // applies baseFilters and baseValidators functions to filters and validators
            for (var key in iris_validator.filters) {
                if (typeof (iris_validator.filters[key]) === 'string' && iris_validator.baseFilters[iris_validator.filters[key]]) {
                    iris_validator.filters[key] = iris_validator.baseFilters[iris_validator.filters[key]];
                }
            }
            for (var key in iris_validator.validators) {
                if (typeof (iris_validator.validators[key]) === 'string' && iris_validator.baseValidators[iris_validator.validators[key]]) {
                    iris_validator.validators[key] = iris_validator.baseValidators[iris_validator.validators[key]];
                }
            }
        },
        serialize: function () { // gets values form the fields and put them to formArray variable
            iris_validator.formArray = $(iris_validator.formSelector).serializeArray();
            $.each($(iris_validator.formSelector).find('input[type="file"]'), function (i, tag) {
                iris_validator.formArray.push({name: tag.name, value: null});
            });
        },
        applyFiltersValidators: function () { // adds event listenters to the form fields for filters and validators
            iris_validator.serialize();
            for (var i in iris_validator.formArray) {
                var elementName = iris_validator.formArray[i]['name'];
                var elementSelector = iris_validator.formSelector + ' [name="' + elementName + '"]';
                var filterActions = 'keypress keyup paste change blur';
                $(elementSelector).on(filterActions, function () {
                    iris_validator.filters['__all'](this);
                });
                if (typeof (iris_validator.filters[elementName]) == 'function') {
                    $(elementSelector).on(filterActions, function () {
                        iris_validator.filters[$(this).attr('name')](this);
                    });
                }
                if (typeof (iris_validator.validators[elementName]) == 'function') {
                    $(elementSelector).on('blur change', function () {
                        if($(this).attr('type') !== 'file') {
                            $(this).val($(this).val().trim());
                        }
                        iris_validator.validators[$(this).attr('name')]($(this));
                    });
                    $(elementSelector).on(filterActions, function () {
                        var elementName = $(this).attr('name');
                        var iris_validator = $(this).parents('form').data('irisFormValidator');
                        var elementSelector = iris_validator.formSelector + ' [name="' + elementName + '"]';
                        if (iris_validator.validateByTimeout.indexOf(elementName) == -1) {
                            return;
                        }
                        if (iris_validator.validateTimeouts[elementName]) {
                            clearTimeout(iris_validator.validateTimeouts[elementName]);
                        }
                        iris_validator.validateTimeouts[elementName] = setTimeout(function (elementName) {
                            iris_validator.validators[elementName]($(elementSelector));
                        }, 1000, elementName);
                    });
                }
                if ($(elementSelector).prop('required')) {
                    $(elementSelector).on(filterActions, function () {
                        iris_validator.filters['__required'](this);
                    });
                    $(elementSelector).on('blur', function () {
                      if($(this).attr('type') !== 'file') {
                        $(this).val($(this).val().trim());
                      }
                      iris_validator.validators['__required'](this);
                      if($(this).val() !== '') {
                        iris_validator.recaptchaRender();
                      }
                    });
                    $(elementSelector).on(filterActions, function () {
                        var elementName = $(this).attr('name');
                        var iris_validator = $(this).parents('form').data('irisFormValidator');
                        var elementSelector = iris_validator.formSelector + ' [name="' + elementName + '"]';
                        if (iris_validator.validateByTimeout.indexOf(elementName) == -1) {
                            return;
                         }
                        if (iris_validator.validateTimeouts[elementName]) {
                            clearTimeout(iris_validator.validateRequiredTimeouts[elementName]);
                        }
                        iris_validator.validateRequiredTimeouts[elementName] = setTimeout(function (elementName) {
                            iris_validator.validators['__required']($(elementSelector));
                        }, 1000, elementName);
                    });
                }
            }
        },
        fillPreSendedData: function () { // gets data from URL params and put them to the form fields to prefill the form
          var urlParams = new URLSearchParams(window.location.search);
          for (var i in iris_validator.formArray) {
            var fieldName = iris_validator.formArray[i]['name'];
            if (urlParams.has(fieldName) && urlParams.get(fieldName).trim() !== '') {
              $(iris_validator.formSelector + ' [name="' +  fieldName + '"]').val(urlParams.get(fieldName).trim());
            }
          }
        },
        init: function (settings) { // initalization of the form
            iris_validator.applySettings(settings);
            iris_validator.applyBaseFunctions();
            iris_validator.applyFiltersValidators();
            iris_validator.fillPreSendedData();
            if(!iris_validator.url.length) {
              iris_validator.url = $(iris_validator.formSelector).attr('action');
            }
            if (iris_validator.focusFirstInput) {
                $(iris_validator.formSelector).find(iris_validator.classToSelector(iris_validator.formElementClass)).first().trigger('focus');
            }
            $(iris_validator.formSubmitButton).on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                // Early lock — stops double-click and keep-clicking-during-ajax from
                // creating duplicate submissions. Also stops anything that re-fires
                // the submit event (Osano hooks, VWO replays, GTM listeners). Lock
                // is released only in sendDataToServer success/error, OR after
                // validation fails (so user can fix the field and retry).
                if (iris_validator.formSubmissionLock) { return; }
                if ($(this).hasClass('disabled')) { return; }
                iris_validator.formSubmissionLock = true;
                // showLoader() swaps the button text to "Loading" immediately so
                // the visitor sees activity during the 2-second validation window
                // instead of the button still saying "Submit". Without this they
                // see "Submit" for 2s → "Loading" → redirect, which looks like a
                // broken double-submit flicker on the sectioned Chilipiper form.
                iris_validator.showLoader().disableSubmit();
                iris_validator.showResult('', true);
                iris_validator.submitForm();
            });
        },
        recaptchaRender: function (force) { // renders recaptcha. Use global variable RCC as reCaprcha key
          if(RCC) {
            var force = force || false;
            if (typeof (grecaptcha) === 'undefined' || !iris_validator.recaptchaAdded) {
                $.getScript('https://www.google.com/recaptcha/api.js?onload=recaptcha2ValidatorOnload&render=explicit', function(){
                    iris_validator.recaptchaAdded = true;
                });
            } else if (force) {
                recaptcha2ValidatorOnload();
            }
          }
        },
        recaptchaExp2Callback: function () { // adds reCaptcha additional data to hidden field
          $(activeFormSelector).find('[name="additionaldata"]').val(RCC);
          $(iris_validator.tokenSelector).val('').trigger('change');
        },
        recaptcha2Callback: function (token) { // adds reCaptcha generated token to hidden field
            $(iris_validator.tokenSelector).val(token).trigger('change');
            iris_validator.showResult('', true);
            $(activeFormSelector).find('[name="additionaldata"]').val('');
            setTimeout(function () {
                $($(activeFormSelector).data('irisFormValidator').formSubmitButton).trigger('focus');
            }, 1000);
        },
        submitForm: function () { // pre-checks the form and initates form submit.
            // formSubmissionLock + disableSubmit() are already set by the click
            // handler before entering here. Trigger synchronous validators by
            // firing change/blur on every field; async ones (reCAPTCHA, phone
            // intlTel) resolve during the 2s wait below. If validation fails
            // the submit button gets the `.disabled` class (set by the field
            // validators), and we release the lock so the user can correct the
            // field and retry. If validation passes, the lock stays held until
            // the AJAX callback in sendDataToServer releases it.
            for (var i in iris_validator.formArray) {
                var elementSelector = iris_validator.formSelector + ' [name="' + iris_validator.formArray[i]['name'] + '"]';
                $(elementSelector).trigger('change');
                $(elementSelector).trigger('blur');
            }
            setTimeout(function () {
                window.VWO = window.VWO || [];
                var formInstance = $(iris_validator.formSelector);
                // Validators mark the submit button `.disabled` when any field is
                // invalid. We temporarily cleared it in the click handler via
                // disableSubmit() for double-click protection — re-check against
                // the real validation state by looking at the form's own error
                // class instead.
                // .text-warning is the form-level result message, not a field —
                // its has-error from a previous failed submit must not block a retry.
                var hasErrors = $(iris_validator.formSelector).find('.' + iris_validator.formInvalidClass).not('.text-warning').length > 0;
                if (!hasErrors) {
                    // Conversion tracking fires in sendDataToServer, only after the
                    // server confirms the lead was accepted.
                    var formData = iris_validator.getFormData();
                    $(iris_validator.formSelector).trigger('ajaxSubmit');
                    iris_validator.sendDataToServer(formData);
                    // NOTE: lock stays TRUE until sendDataToServer's success/error
                    // callback releases it — preventing re-submits during the AJAX.
                } else {
                    if (Object.keys(window.VWO).length > 0) {
                        window.VWO.push(['nls.formAnalysis.markSuccess', formInstance, false]);
                        console.log("VWO success");
                    }
                    // Validation failed — restore button text ("Submit") and
                    // release the lock so the user can fix the field and retry.
                    iris_validator.hideLoader().enableSubmit();
                    iris_validator.formSubmissionLock = false;
                }
            }, 2000);
        },
        getFormData: function () { // returns FormData interface of the form
          if(iris_validator.hasFiles){
            var formData = new FormData();
            for (var i in iris_validator.formArray) {
                if (iris_validator.formArray[i]['name'] === iris_validator.phoneInputName) {
                    formData.append(iris_validator.formArray[i]['name'], iris_validator.destroyMask($(activeFormSelector + ' [name="'+iris_validator.phoneInputName+'"]').val()));
                } else if ($(activeFormSelector + ' [name="' + iris_validator.formArray[i]['name'] + '"]').attr('type') === 'file') {
                    formData.append(iris_validator.formArray[i]['name'], $(activeFormSelector + ' [name="' + iris_validator.formArray[i]['name'] + '"]').prop('files')[0] || '');
                } else {
                    formData.append(iris_validator.formArray[i]['name'], $(activeFormSelector + ' [name="' + iris_validator.formArray[i]['name'] + '"]').val().trim());
                }
            }
          } else {
            var formData = {};
            for (var i in iris_validator.formArray) {
                if (iris_validator.formArray[i]['name'] === iris_validator.phoneInputName) {
                    formData[iris_validator.formArray[i]['name']] = iris_validator.destroyMask($(activeFormSelector + ' [name="'+iris_validator.phoneInputName+'"]').val());
                } else if ($(activeFormSelector + ' [name="' + iris_validator.formArray[i]['name'] + '"]').attr('type') === 'radio') {
                    console.log($(activeFormSelector + ' [name="' + iris_validator.formArray[i]['name'] + '"]:checked'));
                    formData[iris_validator.formArray[i]['name']] = $(activeFormSelector + ' [name="' + iris_validator.formArray[i]['name'] + '"]:checked').val().trim();
                } else {
                    formData[iris_validator.formArray[i]['name']] = $(activeFormSelector + ' [name="' + iris_validator.formArray[i]['name'] + '"]').val().trim();
                }
            }
          }
          return formData;
        },
        showLoader: function () { // Shows loader when form is busy
            if (!$(iris_validator.formSubmitButton).data('textBkp')) {
                $(iris_validator.formSubmitButton).data('textBkp', $(iris_validator.formSubmitButton).html());
            }
            $(iris_validator.formSubmitButton).html('<span class="fa fa-spinner spinning"></span> Loading');
            return this;
        },
        hideLoader: function () { // Hides loader 
            $(iris_validator.formSubmitButton).html($(iris_validator.formSubmitButton).data('textBkp'));
            $(iris_validator.formSubmitButton).removeData('textBkp');
            return this;
        },
        showCaptcha: function () { // Shows reCaptcha
            $(iris_validator.formSelector).find('.g-recaptcha-cont').removeClass('hidden');
            return this;
        },
        hideCaptcha: function () { // Hides reCaptcha
            $(iris_validator.formSelector).find('.g-recaptcha-cont').addClass('hidden');
            return this;
        },
        disableSubmit: function () { // Disables submit button
            $(iris_validator.formSubmitButton).addClass('disabled');
            return this;
        },
        enableSubmit: function () { // Enables submit button
            $(iris_validator.formSubmitButton).removeClass('disabled');
            return this;
        },
        showResult: function (text, success) { // Sows result of execution form submit. "text" - text result, "status" - boolean status of form submit
            $(iris_validator.formSelector + ' .text-warning').removeClass('has-sucess').removeClass('has-error').text('').append(text).addClass(success ? 'has-sucess' : 'has-error');
            return this;
        },
        trackConversion: function () { // Fires conversion events. Call only after the server accepted the lead
            var formInstance = $(iris_validator.formSelector);
            window.VWO = window.VWO || [];
            window.VWO.push(['nls.formAnalysis.markSuccess', formInstance, true]);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'form_submit',
                conversion_url: window.location.href,
                form_name: formInstance.find('[name="form_name"]').val(),
                business_type: formInstance.find('[name="business_type"]').val(),
                product_interest: formInstance.find('[name="product_interest"]').val(),
            });
            return this;
        },
        trackFailure: function (reason) { // Reports a failed submission so lost leads are visible in analytics
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'form_submit_failed',
                conversion_url: window.location.href,
                form_name: $(iris_validator.formSelector).find('[name="form_name"]').val(),
                failure_reason: reason,
            });
            return this;
        },
        sendDataToServer: function (formData, isRetry) { // Sends data to the server
            iris_validator.showLoader().disableSubmit().hideCaptcha();
            submitedFormSelector = iris_validator.formSelector;
            var options = {
                url: iris_validator.url,
                data: formData,
                method: 'POST',
                cache: false,
                dataType: 'json',
                timeout: 45000,
                success: function (data) {
                  var formObject = $(submitedFormSelector).data('irisFormValidator');
                  if(data && data['code'] == 0) {
                    // Terminal success — the form's own success callback runs
                    // the ChiliPiper redirect (POSTs tools.forchili.com, waits
                    // for a 302, then navigates to /thank-you/). Usually 2-15
                    // seconds depending on network + ChiliPiper response.
                    //
                    // Safety fallback (30s): if the browser never navigates,
                    // keep the button disabled and swap its text to a
                    // user-visible error — do NOT call hideLoader() (which
                    // would restore "Submit" and invite a duplicate click).
                    // Button stays non-interactive; visitor is told to retry.
                    iris_validator.trackConversion();
                    formObject.success.call(formObject, data);
                    setTimeout(function (iris_validator) {
                      $(iris_validator.formSubmitButton)
                          .html('Please refresh and try again')
                          .addClass('disabled')
                          .removeData('textBkp');
                      iris_validator.showResult(iris_validator.errorMessages.connectionError, false);
                      // Lock stays TRUE — further clicks on the stuck button
                      // are no-ops. A page reload clears everything.
                    }, 30000, iris_validator);
                  } else if(data && data['code'] == 5){
                    $(iris_validator.tokenSelector).val('').trigger('change');
                    if (typeof (grecaptcha) !== 'undefined') {
                      try { grecaptcha.reset(); } catch (e) {}
                    }
                    iris_validator.trackFailure('captcha');
                    iris_validator.showResult(iris_validator.errorMessages.captchaError, false).hideLoader().enableSubmit().showCaptcha();
                    iris_validator.formSubmissionLock = false;
                  } else {
                    iris_validator.trackFailure('server_code_' + (data ? data['code'] : 'empty'));
                    // code 3 = email rejected by server-side validation; its msg is
                    // written for the visitor ("Please try a different email address").
                    var message = (data && data['code'] == 3 && data['msg']) ? data['msg'] : iris_validator.errorMessages.connectionError;
                    iris_validator.showResult(message, false).hideLoader().enableSubmit().showCaptcha();
                    iris_validator.formSubmissionLock = false;
                  }
                },
                error: function (xhr, textStatus) {
                    // Network drop or timeout: retry once before giving up. The
                    // lead was not saved, so never show the thank-you page here.
                    if (!isRetry && (xhr.status === 0 || textStatus === 'timeout')) {
                        setTimeout(function () {
                            iris_validator.sendDataToServer(formData, true);
                        }, 1500);
                        return;
                    }
                    iris_validator.trackFailure(textStatus + '_' + xhr.status);
                    iris_validator.showResult(iris_validator.errorMessages.connectionError, false).hideLoader().enableSubmit().showCaptcha();
                    iris_validator.formSubmissionLock = false;
                },
            };
            if(iris_validator.hasFiles){
                options.contentType = false;
                options.processData = false;
            }
            $.ajax(options);
        },
        validateEmail: function(element, email) { // Serverside validation of email field
          submitedFormSelector = iris_validator.formSelector;
          if(!iris_validator.emailValidationLock) {
            iris_validator.emailValidationLock = true;
            iris_validator.emailValidationField = element;
            $.ajax({
                url: iris_validator.url + '_emailcheck',
                data: {
                  email: email
                },
                method: 'POST',
                dataType: 'json',
                cache: false,
                success: function (data) {
                  iris_validator.emailValidationLock = false;
                  var formObject = $(submitedFormSelector).data('irisFormValidator');
                  if(data['code'] != 0) {
                    formObject.showError(formObject.emailValidationField, data['msg'], '_validator');
                  }
                  formObject.emailValidationField = null;
                },
                error: function (data) {
                    var formObject = $(submitedFormSelector).data('irisFormValidator');
                    formObject.emailValidationLock = false;
                    formObject.emailValidationField = null;
                },
            });
          }
        }
    };
    iris_validator.init(settings);
    $(element).data('irisFormValidator', iris_validator);
    return iris_validator;
}

function recaptcha2ValidatorOnload() { // reCaptcha default itit
    var currentForm = $(activeFormSelector).data('irisFormValidator');
    var element = $(activeFormSelector).find('.g-recaptcha');
    $(activeFormSelector).find('[name="additionaldata"]').val(RCC);
    var id = element.attr('id');
    var classNames = element.attr('class');
    $(element).replaceWith('<div class="' + classNames + '" id="' + id + '"></div>');
    var element = $(activeFormSelector).find('.g-recaptcha');
    grecaptcha.render($(element).attr('id'), {
        'sitekey': RCC,
        'theme': currentForm.captchaTheme,
        'callback': currentForm.recaptcha2Callback,
        'expired-callback': currentForm.recaptchaExp2Callback,
    });
    currentForm.showCaptcha();
}

